import ShortUniqueId from "short-unique-id";
import customClientAxios from "../customAxios";
import { storage } from "./firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { primaryActionColor, primaryActionColorLight } from "./constants";
import { Parser } from "@json2csv/plainjs";

export const BODHI_LOGIN = "coachlogin.bodhischoolofyoga.com";

export const generateUUID = () => {
  const uuid = new ShortUniqueId({ length: 7 });
  return uuid.rnd(7);
};

export const isNullOrUndefined = (obj) => {
  return obj === null || obj === undefined;
};

// Live-gateway-subscription accessor.
export const getGatewaySub = (bp) => bp?.gatewaySubscription || null;

export const isArrayNullOrUndefined = (arr) => {
  return arr === null || arr === undefined || arr.length === 0;
};

export const getWhichDataToModify = (endpoint) => {
  switch (endpoint) {
    default:
      return "clientUserData";
  }
};

export const FeaturesKeys = {
  event: {
    id: "featureeb5aefdc-f7d4-4cab-8c27-5cfa6c06209a",
    name: "Event",
  },
  oneonone: {
    id: "feature49b723cd-32d2-4cf6-99d0-0e688dfd57cf",
    name: "1-1 Consultation",
  },
  course: {
    id: "feature_7c11a4b9-c6b0-4902-9028-8c9b31c7f7ab",
    name: "Course",
  },
  testimonial: {
    id: "feature_03d589d5-d667-4981-9b00-1ae4d6f7ec6f",
    name: "Testimonial",
  },
  travel: {
    id: "feature_8752ae24-4f3b-45a5-89a4-ceef20c15be7",
    name: "Travel",
  },
  webinar: {
    id: "feature_f44a407e-e5e1-4f5d-825b-dbd486482d94",
    name: "Webinar",
  },
  subscription: {
    id: "feature_47aeb979-c2a5-45ef-a15e-445e41abca17",
    name: "Subscription",
  },
};

export const getApiCallParams = (endpoint, payload, extraHeaders) => {
  return {
    endpoint: endpoint,
    payload: payload,
    extraHeaders,
  };
};

export function handleOpenInNew(url) {
  window.open(url, "_blank");
}

export const getFormatedDateType1 = (date) => {
  return date
    .toLocaleString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })
    .replace(/,/g, "");
};

export const PayoutStatus = {
  Bill: "Bill",
  Paid: "Paid",
  Cancelled: "Cancelled",
  Processing: "Processing",
};

export const getStatusBgColor = (status) => {
  if (status === PayoutStatus.Bill) return "orange";
  if (status === PayoutStatus.Processing) return "blue";
  if (status === PayoutStatus.Paid) return "green";
  if (status === PayoutStatus.Cancelled) return "red";
};

export const formatPrice = (amount, currency, symbol) => {
  const numberFormat = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    currencyDisplay: symbol ? symbol : "symbol",
  });

  const parts = numberFormat.formatToParts(amount);
  let zeroDecimalCurrency = true;
  for (let part of parts) {
    if (part.type === "decimal") {
      zeroDecimalCurrency = false;
    }
  }
  amount = zeroDecimalCurrency ? amount : amount / 100;
  const total = Number(amount).toFixed(2);
  return numberFormat.format(total);
};

export const Currency = {
  INR: "INR",
  USD: "USD",
};

export const callNonStoreApi = (endpoint, payload, headers) => {
  if (isNullOrUndefined(payload)) {
    return customClientAxios().get(endpoint, headers);
  }
  return customClientAxios().post(endpoint, payload, headers);
};

export const handleImageUpload = async (file, userName) => {
  if (file == null) return "";
  const storageRef = ref(storage, `${userName}/${file.name + generateUUID()}`);
  return await uploadBytes(storageRef, file).then(async (snapshot) => {
    return await getDownloadURL(snapshot.ref).then((url) => {
      return url;
    });
  });
};

export const getFeatureKeyFromFeatureId = (featureId) => {
  return Object.values(FeaturesKeys).find(
    (feature) => feature.id === featureId
  );
};

export const GROWEZY_COMMISSION = 0.02;
export const GROWEZY_MAX_COMMISSION = 25000;
export const PhonePe_Convenience = 0.025;
export const Stripe_Convenience = 0.07;
export const Razorpay_INR_Convenience = 0.025;
export const Razorpay_USD_Convenience = 0.035;
export const GST = 0.18;

export const isCustomerOutofIndia = (userCurrency) => {
  return userCurrency !== Currency.INR;
};

export const dashboardFeatureIdentifierBackgroundColor = {
  [FeaturesKeys.event.id]: "#FFE6B9",
  [FeaturesKeys.oneonone.id]: "#fff",
  [FeaturesKeys.course.id]: primaryActionColorLight,
  [FeaturesKeys.travel.id]: "#ECFDF3",
  [FeaturesKeys.subscription.id]: "#ECFDF3",
  [FeaturesKeys.webinar.id]: "#ECFDF3",
};
export const dashboardFeatureIdentifierTextColor = {
  "featurecb083043-0d62-443b-821f-0bbc17e418a8": "#fff",
  [FeaturesKeys.event.id]: "#753c03",
  [FeaturesKeys.oneonone.id]: "#fff",
  [FeaturesKeys.course.id]: primaryActionColor,
  [FeaturesKeys.travel.id]: "#067647",
  [FeaturesKeys.subscription.id]: "#067647",
  [FeaturesKeys.webinar.id]: "#067647",
};

export const handleCopyToClipboard = (text) => {
  return navigator.clipboard.writeText(text);
};

export const handleDownloadCSV = async (data, isDownload) => {
  try {
    const parser = new Parser();
    const csv = parser.parse(data);
    if (isDownload) {
      const element = document.createElement("a");
      element.setAttribute("href", `data:text/csv;charset=utf-8,${csv}`);
      element.setAttribute("download", "Clients");
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    }

    return csv;
  } catch (error) {
    console.error(error);
  }
  return false;
};

export const SettlementStatus = {
  Pending: "Pending",
  Success: "Settled",
  ReadyToProcess: "ready_to_process",
  Processing: "Processing",
  Failed: "Failed",
  Refunded: "Refunded",
};
